module.exports = {
      id: "shortform-usage",
      viewBox: "0 0 13.07 13.758",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#shortform",
      toString: function () {
        return this.url;
      }
    }